import date from '../datePicker.vue'

 const commonInputDate = {
    install:function(Vue) {
        Vue.component('commonInputDate', date)
    }
}

// 导出该组件

export default commonInputDate